import React from 'react';
import { AuthProvider } from '../auth/AuthContext';
import { AppRoutes } from './routes';
import './App.css';

function App() {
    return (
        <AuthProvider>
            <AppRoutes />
        </AuthProvider>
    );
}

export default App;
